/*
 * SPDX-FileCopyrightText: 2022 The HedgeDoc developers (see AUTHORS file)
 *
 * SPDX-License-Identifier: AGPL-3.0-only
 */
import { useDarkModeState } from '../../../hooks/common/use-dark-mode-state'
// import { Branding } from '../../common/branding/branding'
import {
  HedgeDocLogoWithText,
  ScalerLogoType
} from '../../common/hedge-doc-logo/hedge-doc-logo-with-text'
import React from 'react'
import { Navbar } from 'react-bootstrap'

/**
 * Renders the branding for the {@link AppBar}
 */
export const NavbarBranding: React.FC = () => {
  const darkModeActivated = useDarkModeState()

  return (
    <Navbar.Brand>
      <div className='text-secondary text-decoration-none d-flex align-items-center'>
        <HedgeDocLogoWithText
          logoType={darkModeActivated ? ScalerLogoType.LIGHT_LOGO : ScalerLogoType.DARK_LOGO}
          size={15}
        />
        {/* <Branding inline={true} /> */}
      </div>
    </Navbar.Brand>
  )
}
